import React from 'react';
import PropTypes from 'prop-types';
import styles from '../region-entity-banner.module.scss';
import closeIcon from '../../../public/img/close-icon.svg';
import { humanizeNumber } from '../../helpers/formatters';

const MapBanner = ({ council, comparing, onCloseClicked }) => {
  return (
    <div
      className={`${styles.banner} ${styles.mapBanner}`}
      data-comparing={comparing}
    >
      <button className={styles.closeButton} onClick={onCloseClicked}>
        <img src={closeIcon} alt="" style={{ height: 10, width: 10 }} />
      </button>
      <h2 className={styles.mapBannerHeading}>{council.name}</h2>
      <div className={styles.mapBannerDataRow}>
        <div
          className={styles.mapBannerDataBlockWrapper}
          style={{ marginRight: 40 }}
        >
          <img
            src={`${process.env.PUBLIC_URL}/img/people-icon.svg`}
            alt="house icon"
            width="35"
            height="46"
          />
          <div className={styles.mapBannerDataBlockContent}>
            <div className={styles.mapBannerDataNumber}>
              {humanizeNumber(council.population, 'number')}
            </div>
            <span>people</span>
          </div>
        </div>

        <div
          className={styles.mapBannerDataBlockWrapper}
          style={{ marginRight: 40 }}
        >
          <img
            src={`${process.env.PUBLIC_URL}/img/income-icon.svg`}
            alt="people icon"
            width="35"
            height="46"
          />
          <div className={styles.mapBannerDataBlockContent}>
            <div className={styles.mapBannerDataNumber}>
              {humanizeNumber(council.medianIncome, 'number')}
            </div>
            <span>median income</span>
          </div>
        </div>

        <div className={styles.mapBannerDataBlockWrapper}>
          <img
            src={`${process.env.PUBLIC_URL}/img/age-icon.svg`}
            alt="area icon"
            width="35"
            height="46"
          />
          <div className={styles.mapBannerDataBlockContent}>
            <div className={styles.mapBannerDataNumber}>
              {humanizeNumber(council.medianAge, 'number')}
            </div>
            <span>median age</span>
          </div>
        </div>
      </div>
      <div className={styles.mapBannerLegend}>
        <span> This demographic data was sourced from the</span>
        <a
          className={styles.externalLink}
          href="http://www.abs.gov.au/"
          rel="noopener noreferrer"
          target="_blank"
        >
          Australian Bureau of Statistics{' '}
        </a>
        and represents the average of median statistics for the local government
        areas that make up this region
      </div>
    </div>
  );
};

MapBanner.propTypes = {
  council: PropTypes.object,
};

export default MapBanner;



// WEBPACK FOOTER //
// ./src/components/region-map-container/map-banner.js